
export { useAmplitude } from "/builds/dd3tech/wiggot/wiggot-web/packages/analytics/src/providers/amplitud-provider/AmplitudeProvider.tsx"